module.exports = __webpack_public_path__ + "img/20190829150749876.8209fc16.jpg";